import { HASHTAG_CLASS_NAME } from '@features/editor/text-input/content-input/version-b/HashtagInlineTool'
import { styled, theme } from 'twin.macro'
import * as styles from '../articleContentStyles'
import { ArticlePreviewIframeStyle } from '../article-preview'

export const ArticleLayout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: 0 auto 10px;
  padding-bottom: 50px;

  --gutter: calc(100% * 32 / 1168);

  & > .toolbar {
    display: none;

    @media (min-width: ${theme`screens.lg`}) {
      display: block;
      width: calc(100% * 68 / 1168);
      margin-right: var(--gutter);
    }
  }

  & > .article {
    width: 100%;

    @media (min-width: ${theme`screens.lg`}) {
      width: calc(100% * 668 / 1168);
    }
  }

  & > aside {
    display: none;

    @media (min-width: ${theme`screens.lg`}) {
      display: block;
      width: calc(100% * 300 / 1168);
      margin-left: calc(var(--gutter) * 2);
    }
  }

  @media (min-width: ${theme`screens.sm`}) {
    flex-direction: column;
    margin-top: 8px;
  }

  @media (min-width: ${theme`screens.lg`}) {
    flex-direction: row;
    margin-top: 20px;

    & > aside h2.authorPost {
      display: none;
    }
  }

  @media (min-width: ${theme`screens.xl`}) {
    flex-direction: row;
    max-width: 1168px;
  }

  @media (min-width: ${theme`screens.md`}) {
    .article .popular-articles {
      display: none;
    }
  }
`

export const H1 = styled.h1`
  ${styles.h1};
`

export const Article = styled.article`
  background-color: #fff;
  overflow: hidden;
  position: relative;

  padding: 8px 0;

  @media (min-width: ${theme`screens.lg`}) {
    padding: unset;
  }

  .post {
    padding: 0 20px;

    @media (min-width: ${theme`screens.lg`}) {
      padding: unset;
    }
  }

  ${H1} {
    margin-block-end: 12px;
    padding: 0 20px;
    @media (min-width: ${theme`screens.lg`}) {
      padding: unset;
      margin-block-end: 16px;
      padding-inline: unset;
    }
  }

  & > .article-user-info {
    padding: 0 20px;
    margin-block-start: 16px;

    @media (min-width: ${theme`screens.lg`}) {
      padding: unset;
    }
  }
`

export const ArticleContentFooter = styled.footer`
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  font-size: 0.8em;
  color: #ababab;
`

export const StyledArticleContent = styled.div`
  hr {
    border: solid 1px #f5f5f5;
    margin: 1em 0;
  }

  h2 {
    ${styles.h2}
  }

  h3 {
    ${styles.h3}
  }

  ul,
  ol {
    ${styles.list}
  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: order;
  }

  table td {
    padding: 10px;
    padding-bottom: 15px;
    line-height: 1.8em;
  }

  b,
  blockquote,
  p {
    ${styles.paragraph};
  }

  blockquote,
  .quote {
    ${styles.quote};
  }

  b:empty,
  li:empty,
  blockquote:empty,
  p:empty {
    display: none;
  }

  a {
    ${styles.link};
  }

  b,
  strong {
    ${styles.bold};
  }

  i {
    font-style: italic;
  }

  table,
  iframe {
    margin: 10px 0;
    min-width: initial;
    width: 100%;
  }

  img {
    min-width: initial;
    width: 100%;
    max-width: 100%;
    margin: 10px 0;
  }

  .imgWrap {
    margin: 10px 0;
  }

  .imgWrap img {
    margin: 0 auto;
  }

  mark {
    ${styles.marker};
  }

  ${'.' + HASHTAG_CLASS_NAME} {
    ${styles.link};
    cursor: pointer;
  }

  .delimiter {
    ${styles.delimiter}
  }

  .ytIframeContent,
  .fbIframeContent {
    display: block;
    position: relative;
    padding-top: 56.25%;
    margin-bottom: 20px;
  }

  .ytIframeContent iframe,
  .fbIframeContent iframe {
    width: 100%;
    max-width: initial;
    border: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    margin: 0;
  }

  .ad-delimiter-top {
    position: relative;
    margin: 16px auto;
    color: #999999;
    text-align: center;
    font-size: 14px;
    max-width: 100%;

    &::before,
    &::after {
      content: '';
      display: block;
      /* full width - text width - text padding - article padding */
      width: calc((100vw - 168px - 24px - 40px) / 2);
      height: 1px;
      background: #e6e6e6;
      position: absolute;
    }

    &::before {
      left: 0;
      top: 50%;
    }

    &::after {
      right: 0;
      top: 50%;
    }

    @media (min-width: ${theme`screens.md`}) {
      &::before,
      &::after {
        width: 236px;
      }
    }
  }

  .ad-delimiter-bottom {
    display: block;
    border-top: 1px solid #e6e6e6;
    width: 100%;
    margin-bottom: 12px;
    margin-top: 16px;
  }

  ${ArticlePreviewIframeStyle}
`

export const DownloadAppBannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 100%;
  z-index: 1000;
`
